(function () {
    'use strict';

    angular
        .module('app')
        .directive('drvGuidInput', drvGuidInput);
        
        drvGuidInput.$inject = [];

        /**
         * @ngdoc directive
         * @name drvGuidInput
         * @description GUID input which includes validation.
         *
         * @param {string} value - GUID
         * @param {object} field - An entity field object
         */
        function drvGuidInput() {
            drvGuidInputCtrl.$inject = ['$element', 'uuid'];

            return  {
                templateUrl: 'app/fieldinput/guid-input.tmpl.html',
                require: "ngModel",
                scope: {
                },
                controller: drvGuidInputCtrl,
                controllerAs: 'drvCtrl',
                bindToController: {
                    value: '=ngModel',
                    field: '='
                },
                link: link
            };

            function drvGuidInputCtrl($element, uuid) {
                /* jshint validthis:true */
                var drvCtrl = this;
                drvCtrl.validateGUID = validateGUID;
                drvCtrl.calculateInputWidth = calculateInputWidth;

                function calculateInputWidth() {
                    if ($element[0].firstElementChild.clientWidth === 0) {
                        return null;
                    }

                    var result = 30;
                    var elementSmallerThanLength = false;



                    if ((!angular.isUndefined(drvCtrl.field.Length) && drvCtrl.field.Length !== null) || (!angular.isUndefined(drvCtrl.value) && drvCtrl.value !== null && drvCtrl.value.length > 30)) {
                        var length;

                        if (!angular.isUndefined(drvCtrl.field.Length) && drvCtrl.field.Length !== null) {
                            length = drvCtrl.field.Length;
                        }
                        else {
                            length = drvCtrl.value.length;
                        }

                        var pixelNeeded = (length * 12) + 60;
                        if (pixelNeeded > $element[0].firstElementChild.clientWidth) {
                            elementSmallerThanLength = true;
                        }
                        else {
                            result = length + 5;
                        }
                    }

                    if (($element[0].firstElementChild.clientWidth < 380 && (angular.isUndefined(drvCtrl.field.Length) || drvCtrl.field.Length === null)) || elementSmallerThanLength) {
                        result = Math.floor($element[0].firstElementChild.clientWidth / 12) - 5;
                    }

                    return result * 0.7;
                }

                /*
                 * Check to see if GUID is valid
                 */
                function validateGUID(guid) {
                    var guidRegex = /^[0-9a-f]{8}-?[0-9a-f]{4}-?[1-5][0-9a-f]{3}-?[89ab][0-9a-f]{3}-?[0-9a-f]{12}$/i;
                    var valid = false;

                    if (!_.isNil(guid) && guid !== '') {
                        valid = guidRegex.test(guid);
                    } else {
                        valid = true;
                    }

                    return valid;
                }
            }
        }

        /*
         * Link function which will handle validation
         */
        function link($scope, $element, $attrs, $ctrl) {
            $scope.pni[$scope.drvCtrl.field.Name].$validators.formatValid = function required(modelValue, viewValue) {
                return $scope.drvCtrl.validateGUID(modelValue);
            };
        }
})();